import { getOneFromMultiProxy } from '../claimData.helpers';
import { claimsKeys } from '../../../helpers/formData/formData';
import {
  glassOptions,
  glassCircumstances,
} from '../../../helpers/formData/propertyFormData';
import { getGlassBusinessWhatDamagedValueProxy } from './claimData.helpers';

export default {
  'glass-breakage-business_options': [
    claimsKeys.property.CASE,
    getOneFromMultiProxy({
      break: glassOptions.BREAK,
      blindness: glassOptions.BLINDESS,
      different: glassOptions.OTHER,
    }),
  ],
  'glass-breakage-business_description': claimsKeys.property.CASE,
  'glass-breakage-business_circumstances': [
    claimsKeys.property.RESULT_STRUCTURE,
    getOneFromMultiProxy({
      wind: glassCircumstances.WIND,
      'personal-negligence': glassCircumstances.PERSONAL_NEGLIGENCE,
      'external-negligence': glassCircumstances.EXTERNAL_NEGLIGENCE,
      different: glassCircumstances.OTHER,
    }),
  ],
  'glass-breakage-business_what-damaged': [
    claimsKeys.property.CAUSE_NOTE,
    getGlassBusinessWhatDamagedValueProxy,
  ],
};
